import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Stili from "@/pages/Stili";
import Prenota from "@/pages/Prenota";
import Studio from "@/pages/Studio";
import Profilo from "@/pages/Profilo";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/stili" element={<Stili />} />
            <Route path="/prenota" element={<Prenota />} />
            <Route path="/studio" element={<Studio />} />
            <Route path="/profilo" element={<Profilo />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#1C1A16",
            border: "1px solid #2E2A24",
            color: "#F4EFE8",
            fontFamily: "DM Sans, sans-serif",
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
